import { useCallback, useEffect, useState } from 'react';
import { AuditHistory, defaultAuditHistory } from '.';
import useAuditApi from '../../api/useAuditApi';

export const useAudit = (id: string) => {
  const [auditHistory, setAuditHistory] = useState<AuditHistory>(defaultAuditHistory);

  const { getAuditHistory } = useAuditApi();

  const fetchAuditHistory = useCallback(async () => {
    const result = await getAuditHistory(id);
    setAuditHistory(result);
  }, []);

  useEffect(() => {
    (async () => {
      await fetchAuditHistory();
    })();
  }, [id]);

  return {
    auditHistory,
    setAuditHistory,
    fetchAuditHistory,
  };
};
